import { render, staticRenderFns } from "./PlusProductValueModal.vue?vue&type=template&id=47dc8abc&scoped=true"
import script from "./PlusProductValueModal.vue?vue&type=script&lang=ts"
export * from "./PlusProductValueModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47dc8abc",
  null
  
)

export default component.exports